// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import {is_Empty} from "./utils/utils.js";

// 按需导入elementUI组件。
import element from './element'
// 设置elementUI主题颜色。
import '../static/css/element-variables.scss'
// resetcss
import '../static/css/reset.css';
// 常用css
import '../static/css/main.css';
import {post, get, upload, postWithUserInfo, jsonPost} from './http/api'

import './globalComponents';

import './utils/mixin.js'
import store from './store'

import permission from "./utils/permission"

// 图片放大工具
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";


//工具
import {encrypt} from './utils/utils.js'

Vue.config.productionTip = false
Vue.prototype.get = get
Vue.prototype.post = post
Vue.prototype.postWithUserInfo = postWithUserInfo
Vue.prototype.jsonPost = jsonPost

Vue.prototype.upload = upload
Vue.prototype.encrypt = encrypt;
Vue.use(element);
Vue.use(preview);
Vue.use(permission)

/* eslint-disable no-new */


router.beforeEach((to, from, next) => {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.match(/windowswechat/i) == "windowswechat" && to.name !== 'browserError') {
        next({path: "/browserError"})
        return;
    }

    let isLogin = !is_Empty(store.state.memberInfo);
    document.title = `${to.meta && to.meta.title ? `${to.meta.title} - ` : ''}益发商城`;
    if (to.meta.requireAuth) {

        if (isLogin) {
            next()
        } else {
            // 如果没有登录 去登录
            next('/login')
        }

    } else {
        next()
    }

});


new Vue({
    el: '#app',
    router,
    components: {App},
    store,
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js